/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FaSearch } from 'react-icons/fa';
import { SearchPublishedContent } from '@blaze-cms/nextjs-tools';
import { Link } from '@blaze-cms/nextjs-components';
import SearchLink from './SearchLink';
import { buildYachtInfo, getParsedEntity, getParsedResultKeys } from './helpers';
import { AVAILABLE_SEARCH_ENTITIES, SEARCH_FIELDS_LIMIT, SEARCH_PATH_NAME } from '../../constants';

const SearchContent = ({
  handleSearchTerm,
  setIsSearchBarOpen,
  isSearchBarOpen,
  currentSearchTerm,
  closeSearchBar,
  router
}) => {
  const inputRef = useRef(null);
  const handleRoute = ({ pathname, query }) => {
    router.push({
      pathname,
      query
    });
  };

  const parsedResultKeys = getParsedResultKeys();

  return (
    <SearchPublishedContent
      entities={AVAILABLE_SEARCH_ENTITIES}
      onEnterPress={() =>
        handleRoute({
          pathname: `/${SEARCH_PATH_NAME}`,
          query: {
            search_term: currentSearchTerm
          }
        })
      }
      resultKeys={parsedResultKeys}
      placeholder="TYPE TO SEARCH..."
      onChange={handleSearchTerm}
      SearchIcon={() => (
        <i>
          <FaSearch />
        </i>
      )}
      getIsOpenSearchBar={state => setIsSearchBarOpen(state)}
      isSearchBarOpen={isSearchBarOpen}
      fields={SEARCH_FIELDS_LIMIT}
      inputRef={isSearchBarOpen ? inputRef : null}>
      {({ results }) => {
        const shouldDisplayResults = !!results.length && isSearchBarOpen;
        const divClass = classnames({
          'search-modal__content-show': shouldDisplayResults,
          'search-modal__content': !shouldDisplayResults
        });
        return (
          <div className={divClass}>
            {shouldDisplayResults && (
              <>
                {results.map(
                  ({
                    __typename: entity,
                    name,
                    url,
                    image,
                    built_on_year: builtOnYear,
                    length_overall: lengthOverall
                  }) => {
                    const parsedEntity = getParsedEntity(entity);
                    const yachtInfo = buildYachtInfo({
                      name,
                      builtOnYear,
                      lengthOverall,
                      parsedEntity
                    });

                    return (
                      <Link key={name} href={url} onClick={closeSearchBar}>
                        <div className="search-modal-result">
                          {image && image.url && (
                            <img
                              src={image.url}
                              alt="miniature"
                              className="search-modal-miniature"
                            />
                          )}
                          <p>{yachtInfo}</p>
                        </div>
                      </Link>
                    );
                  }
                )}
                <SearchLink currentSearchTerm={currentSearchTerm} handleRoute={handleRoute} />
              </>
            )}
            {!results.length && currentSearchTerm && (
              <SearchLink currentSearchTerm={currentSearchTerm} handleRoute={handleRoute} />
            )}
          </div>
        );
      }}
    </SearchPublishedContent>
  );
};

SearchContent.propTypes = {
  handleSearchTerm: PropTypes.func.isRequired,
  setIsSearchBarOpen: PropTypes.func.isRequired,
  isSearchBarOpen: PropTypes.bool.isRequired,
  currentSearchTerm: PropTypes.string.isRequired,
  closeSearchBar: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired
};

export default SearchContent;
